import { render, staticRenderFns } from "./Valoraciones.vue?vue&type=template&id=09cb9f16&scoped=true"
import script from "./Valoraciones.vue?vue&type=script&lang=js"
export * from "./Valoraciones.vue?vue&type=script&lang=js"
import style0 from "./Valoraciones.vue?vue&type=style&index=0&id=09cb9f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cb9f16",
  null
  
)

export default component.exports